<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="nickname" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminCreatePharmacyNicknameLabel">
    Pharmacy Nickname
    <span class="text-danger-text">*</span>
  </label>
  <input
    id="nickname"
    type="text"
    formControlName="nickname"
    placeholder="Enter pharmacy nickname"
    i18n-placeholder="@@adminCreatePharmacyFormNicknamePlaceholder"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="pharmacyForm().get('nickname')?.invalid && pharmacyForm().get('nickname')?.touched" />
  @if (pharmacyForm().get("nickname")?.invalid && pharmacyForm().get("nickname")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("nickname")?.errors?.["required"]) {
        <span i18n="@@adminCreatePharmacyFormErrorNicknameRequired">Pharmacy Nickname is required</span>
      }
      @if (
        pharmacyForm().get("nickname")?.errors?.["minlength"] && !pharmacyForm().get("nickname")?.errors?.["pattern"]
      ) {
        <span i18n="@@adminCreatePharmacyFormErrorNicknameMinLength">
          Pharmacy Nickname must be at least 3 characters
        </span>
      }
      @if (
        pharmacyForm().get("nickname")?.errors?.["maxlength"] && !pharmacyForm().get("nickname")?.errors?.["pattern"]
      ) {
        <span i18n="@@adminCreatePharmacyFormErrorNicknameMaxLength">
          Pharmacy Nickname cannot exceed 255 characters
        </span>
      }
      @if (pharmacyForm().get("nickname")?.errors?.["pattern"]) {
        <span i18n="@@adminCreatePharmacyFormErrorNicknamePattern">
          Nickname can only contain letters, numbers, and spaces
        </span>
      }
    </span>
  }
</div>
